module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[2]489.0b7152d.woff2";